import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgActions = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 6,
	viewBox: "0 0 25 6",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.5 -9.78258e-07C1.84315 -1.51854e-06 0.5 1.34314 0.5 3C0.5 4.65685 1.84315 6 3.5 6C5.15685 6 6.5 4.65685 6.5 3C6.5 1.34315 5.15685 -4.37981e-07 3.5 -9.78258e-07Z",
			fill: "#0177A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.5 -9.78258e-07C10.8431 -1.51854e-06 9.5 1.34314 9.5 3C9.5 4.65685 10.8431 6 12.5 6C14.1569 6 15.5 4.65685 15.5 3C15.5 1.34315 14.1569 -4.37981e-07 12.5 -9.78258e-07Z",
			fill: "#0177A3"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5 -9.78258e-07C19.8431 -1.51854e-06 18.5 1.34314 18.5 3C18.5 4.65685 19.8431 6 21.5 6C23.1569 6 24.5 4.65685 24.5 3C24.5 1.34315 23.1569 -4.37981e-07 21.5 -9.78258e-07Z",
			fill: "#0177A3"
		})
	]
});
export default SvgActions;
